import type { QueryClient } from "@tanstack/react-query";
import type {
  PaginatedResponse,
  StudyGroupMembershipResponse,
} from "@/lib/humhub-api/types";
import { studyGroupKeys } from "@/lib/queryKeys/studyGroupKeys";

/**
 * studyGroupMemberships / studyGroupAdmins のキャッシュに対して
 * ブロック状態を即時反映するヘルパー。
 */
export const updateMembershipBlockStatus = (
  queryClient: QueryClient,
  userId: number,
  isBlocked: boolean,
) => {
  queryClient.setQueriesData<
    PaginatedResponse<StudyGroupMembershipResponse> | undefined
  >(
    {
      predicate: (query) => {
        const key = query.queryKey[0];
        return (
          key === studyGroupKeys.membershipsRoot[0] ||
          key === studyGroupKeys.adminsRoot[0]
        );
      },
    },
    (data) => {
      if (!data?.results) return data;

      return {
        ...data,
        results: data.results.map((member) => {
          if (member.user?.id !== userId) return member;
          return {
            ...member,
            is_blocked_by_current_user: isBlocked,
            user: {
              ...member.user,
              is_blocked_by_current_user: isBlocked,
            },
          };
        }),
      };
    },
  );
};
